const config =  {
  "aws_project_region": "ap-southeast-2",
  "aws_cognito_identity_pool_id": "",
  "aws_cognito_region": "ap-southeast-2",
  "aws_user_pools_id": "ap-southeast-2_yojnk8YRj",
  "aws_user_pools_web_client_id": "41n6fk0fkuma6tcrltqhs76l5d",
};
export default config;

